
import React, { Component } from "react";
import { Link } from "gatsby";


class BookAppointment extends Component {
  constructor() {
    super();
    this.state = {
     };
}


render(){
  return(
    <section className="appointment-sec">
    <div className="container-fluid">
        <div className="appointment-inner">
            <div className="row">
                <div className="col-md-5">
                    <div className="text-box wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".1s">
                        <h3>Book an appointment</h3>
                        <p>Submit an enquiry. You'll receive a call from our team in 48 hours. Get a free consultation. Get a quotation & decide on the treatment. </p>
                        <Link to="/free-consultation"><span style={{textTransform:"uppercase"}}>Book a free consultation</span></Link>
                    </div>
                </div>
                <div className="col-md-7">
                    <div className="image-holder wow fadeInRight" data-wow-duration="1s" data-wow-delay=".1s">
                        <img data-src="https://res.cloudinary.com/image/upload/v1604992003/NewHome/appointment-img-min_bh9c2j.png" alt="" className="img-fluid lazyload" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
  )
}

}

export default BookAppointment;

  
  

  



  

 
  
 